import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const scholarshipProgramService = {
    async getAll(): Promise<any> {
        try {
            const response = await apiClient.get<any>(
                `${BASE_URL}/api/v1/scholarship-program/all`
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching scholarship program list:", error);
            throw error;
        }
    },
}

export default scholarshipProgramService;